// extracted by mini-css-extract-plugin
var _1 = "info";
export { _1 as "info" }
